"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Textarea = _interopRequireDefault(require("./Textarea.style"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var Textarea = function Textarea(_ref) {
  var disabled = _ref.disabled,
    id = _ref.id,
    onBlur = _ref.onBlur,
    placeholder = _ref.placeholder,
    value = _ref.value,
    onChange = _ref.onChange,
    hasErrors = _ref.hasErrors,
    maxLength = _ref.maxLength,
    scrollable = _ref.scrollable,
    className = _ref.className,
    onKeyDown = _ref.onKeyDown,
    ariaLabel = _ref.ariaLabel;
  return /*#__PURE__*/_react["default"].createElement(_Textarea["default"], {
    className: className,
    disabled: disabled,
    placeholder: placeholder,
    id: id,
    onChange: onChange,
    onBlur: onBlur,
    onKeyDown: onKeyDown,
    value: value,
    rows: "1",
    maxLength: maxLength,
    haserrors: hasErrors ? "".concat(hasErrors) : null,
    scrollable: scrollable ? "".concat(scrollable) : null,
    autoComplete: "off",
    "aria-label": ariaLabel || placeholder
  });
};
Textarea.propTypes = {
  hasErrors: _propTypes["default"].bool,
  maxLength: _propTypes["default"].number,
  /**
   * If `true`, the input will be disabled.
   */
  disabled: _propTypes["default"].bool,
  /**
   * The id of the `textarea` element.
   */
  id: _propTypes["default"].string,
  /**
   * @ignore
   */
  onBlur: _propTypes["default"].func,
  /**
   * @ignore
   */
  onChange: _propTypes["default"].func.isRequired,
  /**
   * The short hint displayed in the input before the user enters a value.
   */
  placeholder: _propTypes["default"].string,
  /**
   * The input value, required for a controlled component.
   */
  value: _propTypes["default"].string,
  scrollable: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  onKeyDown: _propTypes["default"].func,
  ariaLabel: _propTypes["default"].string
};
Textarea.defaultProps = {
  hasErrors: false,
  maxLength: null,
  disabled: false,
  id: undefined,
  onBlur: undefined,
  onKeyDown: undefined,
  placeholder: '',
  value: '',
  scrollable: false,
  className: '',
  ariaLabel: ''
};
Textarea.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Textarea",
  "props": {
    "hasErrors": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "maxLength": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "disabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "If `true`, the input will be disabled.",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "id": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "The id of the `textarea` element.",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "onBlur": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "@ignore",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "onKeyDown": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "placeholder": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "The short hint displayed in the input before the user enters a value.",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "value": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "The input value, required for a controlled component.",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "scrollable": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "className": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "ariaLabel": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "onChange": {
      "description": "@ignore",
      "type": {
        "name": "func"
      },
      "required": true
    }
  }
};
var _default = /*#__PURE__*/(0, _react.memo)(Textarea);
exports["default"] = _default;